/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { Inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { UnespCoreEnvironment } from 'src/libs/unesp-core'
import { identity, Observable } from 'rxjs'
import { InscricaoComplemento } from '../models/inscricao-complemento'
import { ErrorHandlerService } from './error-handler.service'
import { ChunkedDownloadDTO } from '../models/chunked-download.dto'

@Injectable({
  providedIn: 'root',
})
export class InscricaoComplementoService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  alterar(id: number, complemento: InscricaoComplemento): Observable<InscricaoComplemento> {
    return this.http
      .put<InscricaoComplemento>(`${this.baseUrl}/inscricao-complemento/${id}`, complemento)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  obterUrlsDownloadChunks(idInscricao: number, id: number | string, idConcurso: number | string, codigoOrgao: string): Observable<ChunkedDownloadDTO> {    
    return this.http
      .get<any>(`${this.baseUrl}/concurso/${idConcurso}/inscricao/${idInscricao}/complemento/${id}/download-presigned-url?codigoOrgao=${codigoOrgao}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
